import { render } from "./ClinicalFormulationDrugExemptionsForm.vue?vue&type=template&id=fa1f45b2"
import script from "./ClinicalFormulationDrugExemptionsForm.vue?vue&type=script&lang=js"
export * from "./ClinicalFormulationDrugExemptionsForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/packs/components/ClinicalFormulationDrugExemptionsForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fa1f45b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fa1f45b2', __exports__)) {
    api.reload('fa1f45b2', __exports__)
  }
  
  module.hot.accept("./ClinicalFormulationDrugExemptionsForm.vue?vue&type=template&id=fa1f45b2", () => {
    api.rerender('fa1f45b2', render)
  })

}


export default __exports__